export default "__VITE_ASSET__qIQVqiWf__"